/**
 * VSI.3.1 — Dispatcher für Visual Learning Objects.
 *
 * Routet `course.visual_objects` (optional gefiltert je Anker) an die per Renderer-Registry
 * zugeordneten Komponenten. Reine Darstellung, keine Fachlogik, keine Mutation. Fail-closed:
 * unbekannte Typen werden ausgelassen.
 *
 * Hinweis (VSI.3.1): Dies ist Fundament. Der Live-Render-Pfad von VSI.1 in MonteurAufgabe bleibt
 * unverändert (byte-identisch). Die Aktivierung dieses Dispatchers im Lernfluss erfolgt, sobald
 * mehrere VLO-Typen/Anker existieren (VSI.3.3 / VSI.3.4).
 */
import { getRenderer } from "@/vsi/rendererRegistry";

export function VisualObjects({ objects, sourceObjects = null, anchor = null, lang = null }) {
  if (!Array.isArray(objects) || objects.length === 0) return null;
  const list = anchor ? objects.filter((o) => o && o.anchor === anchor) : objects;
  if (list.length === 0) return null;
  // AP-LANG-SOURCE: deutsche Quell-VLOs (falls vorhanden) je vlo_type zuordnen, damit die
  // Renderer den sprachneutralen Lehrbild-Lookup durchführen können. Anzeige bleibt übersetzt.
  const srcByType = {};
  if (Array.isArray(sourceObjects)) {
    sourceObjects.forEach((o) => {
      if (o && o.vlo_type) srcByType[o.vlo_type] = o;
    });
  }
  return (
    <>
      {list.map((vlo) => {
        const Renderer = getRenderer(vlo?.vlo_type);
        if (!Renderer) return null;
        return (
          <Renderer key={vlo.id} vlo={vlo} sourceVlo={srcByType[vlo?.vlo_type] || null} lang={lang} />
        );
      })}
    </>
  );
}
